/**
 * Quick Add dropdown menu — the header-bar entry point for adding
 * items that don't yet live in the product catalog (Custom Item) or
 * for opening the category-specific Quick Add dialogs (Laminate,
 * Highlighter, Hardware, Adhesive, Veneer).
 *
 * Extracted from ProductsPage.js — 56 LOC of pure
 * JSX with no internal state. Every action lives on the caller as a
 * callback so this stays trivial to test + reuse.
 */
import React from 'react';
import { Button } from '../../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu';
import { Zap, ChevronDown, Palette, Sparkles, Wrench, Pipette, TreePine } from 'lucide-react';


export function QuickAddMenu({
  onCustomItem,
  onAddLaminate,
  onAddHighlighter,
  onAddHardware,
  onAddAdhesive,
  onAddVeneer,
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="rounded-xl bg-white border-heda-line text-heda-ink hover:bg-white hover:border-heda-gold hover:text-heda-gold text-xs sm:text-sm h-9"
          data-testid="quick-add-menu-btn"
        >
          <Zap className="w-3 h-3 sm:w-4 sm:h-4 mr-1" /> Quick Add <ChevronDown className="w-3 h-3 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-xs text-heda-mute">Add to Quotation Only</DropdownMenuLabel>
        <DropdownMenuItem onClick={onCustomItem} className="cursor-pointer" data-testid="quick-add-custom-item">
          <Zap className="w-4 h-4 mr-2 text-heda-gold" />
          <span>Custom Item</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs text-heda-mute">Save &amp; Remember</DropdownMenuLabel>
        <DropdownMenuItem onClick={onAddLaminate} className="cursor-pointer" data-testid="quick-add-laminate">
          <Palette className="w-4 h-4 mr-2 text-sky-700" />
          <span>Add Laminate</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddHighlighter} className="cursor-pointer" data-testid="quick-add-highlighter">
          <Sparkles className="w-4 h-4 mr-2 text-heda-gold" />
          <span>Add Highlighter</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddHardware} className="cursor-pointer" data-testid="quick-add-hardware">
          <Wrench className="w-4 h-4 mr-2 text-heda-sub" />
          <span>Add Hardware</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddAdhesive} className="cursor-pointer" data-testid="quick-add-adhesive">
          <Pipette className="w-4 h-4 mr-2 text-heda-gold" />
          <span>Add Adhesive</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddVeneer} className="cursor-pointer" data-testid="quick-add-veneer">
          <TreePine className="w-4 h-4 mr-2 text-amber-700" />
          <span>Add Veneer</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
